const defaultStatus = {
    title: '고객센터',
    tabId: 'more'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/center.js